import { useEffect, useMemo, useState } from 'react';
import { useMediaMessages } from '../../../Slice';

const cache = {};

export const useMergedMediaMessages = (channelId, mediaTypeArr = []) => {
   const [fetchedMediaMessages, setFetchedMediaMessages] = useState([]);

   // Get media messages from Redux
   const stateMediaMessages = useMediaMessages(channelId, mediaTypeArr);

   // Fetch media messages from SDK
   useEffect(() => {
      const cacheKey = `${channelId}-${mediaTypeArr.join(',')}`;

      if (cache[cacheKey]) {
         setFetchedMediaMessages(cache[cacheKey]);
      }
      /**   const getMediaMessage = async () => {
          const [isLoading, setIsLoading] = useState(false);
         if (!channelId) {
            return;
         }
         setIsLoading(true);
         try {
            const fetchedData = await MFChannel.getMediaMessages({ channelId, messageTypes: mediaTypeArr });
            const messages = fetchedData?.data || [];
            setFetchedMediaMessages(messages);
            cache[cacheKey] = messages;
         } catch (error) {
         }
         setIsLoading(false);
      };

      getMediaMessage(); */
   }, [channelId]);

   const mergedMediaMessages = useMemo(() => {
      const fetchedMessagesMap = new Map();

      // Populate map with fetched messages
      fetchedMediaMessages.forEach(msg => {
         fetchedMessagesMap.set(msg.msgId, msg);
      });

      // Maintain stateMediaMessages order while merging
      const mergedMessages = stateMediaMessages.map(stateMsg => {
         if (fetchedMessagesMap.has(stateMsg.msgId)) {
            return {
               ...fetchedMessagesMap.get(stateMsg.msgId), // Keep fetched message properties
               ...stateMsg, // Override with state message properties
               msgBody: {
                  ...fetchedMessagesMap.get(stateMsg.msgId).msgBody,
                  ...stateMsg.msgBody,
                  media: {
                     ...fetchedMessagesMap.get(stateMsg.msgId).msgBody.media,
                     ...stateMsg.msgBody.media,
                  },
               },
            };
         } else {
            return stateMsg; // Keep state message if not in fetched messages
         }
      });

      // Append fetched messages that are NOT in stateMediaMessages
      fetchedMessagesMap.forEach((msg, msgId) => {
         if (!stateMediaMessages.some(stateMsg => stateMsg.msgId === msgId)) {
            mergedMessages.push(msg);
         }
      });

      // Sort by timestamp to ensure correct order
      return mergedMessages;
   }, [stateMediaMessages, fetchedMediaMessages]);

   return { mergedMediaMessages };
};
